import React, { useState , useEffect } from "react";
import ReactECharts from "echarts-for-react";
import "./category.scss";
import dropicon from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Draganddropicon.svg"
import { useDispatch, useSelector } from "react-redux";
import { clearInternalCategoryTopFive } from "../../../../../../../Redux/Slice";
import boximg from "../../../../../../../Assets/AppComponent/Group 427320177.svg";


export default function TopIssuesDonutChart({
       datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range,
  Client_id


}) {
  const state = useSelector((state)=>state)
  const dispatch = useDispatch()

  const ChartResponse = useSelector((state)=>state.InternalIssueCategoryTopFive.internalCategoryTopFive)
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Week");

  const options = ["This Week", "This Month", "This Year"];

  const handleSelect = (option) => {
    setSelectedFilter(option.split(" ")[1]); // Sets "Week", "Month", etc.
    setShowDropdown(false);
  };

      useEffect(()=>{
                if(state.ClientBranchIDs.SUBROLE == 3){

  const payload ={
    // state:datas?.state,
    // region:datas?.region,
    // zone:datas?.zone,
     priority:PriorityValues,
     department:Client,
     date:date ,
                  //  client:Client_id

  }
    dispatch(clearInternalCategoryTopFive(payload))
}
  },[date  ,PriorityValues , Client  ])




const data = ChartResponse.slice(0, 5).map((item) => ({
  value: Math.round(item.ticket_percentage),
  name: item.internal_category_id__issue_category_id__name,
}));





const donutChartOptions = {
  title: {
   left: "left",
    top: 10,
    textStyle: {
      fontSize: 16,
      fontWeight: "bold",
    },
  },
  tooltip: {
  trigger: "item",
      formatter: (params) => {
      const value = data.find(
        (d) => d.name === params.name
      )?.value;
      return `${params.name}: ${value}%`;
    },

},
  legend: {
    orient: "vertical",
    // right: 0,
      right: 0,
    top: "center",
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 30,
formatter: (name) => {
  const maxLength = 20;
  const displayName = name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
  const item = data.slice(0, 5).find((d) => d.name === name);
  return item
    ? `{a|${displayName}}  {b|${parseFloat(item.value).toFixed(2)}%}`
    : displayName;
},
    textStyle: {
      rich: {
        a: {
          fontSize: 13,
          color: "#333",
          width: 190,
                padding: [0, 5, 0, 10], // 👈 Adds left padding to the legend text
        },
        b: {
          fontSize: 13,
          color: "#234492",
        },
      },
    },
  },
  color: ["#234492", "#F99D1C", "#2F3C91", "#66D19E", "#4EC0CA"],
  series: [
    {
      name: "Issues",
      type: "pie",
    radius: ["45%", "85%"], // 🔼 Bigger inner & outer radius
      center: ["25%", "50%"],
          avoidLabelOverlap: false,
      label: { show: false },
      labelLine: { show: false },
          itemStyle: {
      borderColor: "#fff",       // White gap between slices
      borderWidth: 3,            // Thickness of the gap
        borderRadius: 10, // ✅ this creates rounded ends on pie slices

    },

      data,
    },
  ],
};

  return (
    <div className="top-issues-chart filter-dropdown">
      <div className="chart-header">
        <h3>Top 5 Issue Category</h3>
        
      </div>

           {data?.length > 0 ? (
  <ReactECharts
    option={donutChartOptions}
    className="echarts-container"
    style={{ width: 620, height: "80%" }}
  />
) : (
  <div className="Dusbinbacktabls" style={{height:"387px"}}>
    <div>
      <img src={boximg} />
      <p className="text-center">No Data Available</p>
    </div>
  </div>
)}

    </div>
  );
}
